{
  "keym": {
    "layer": "segmentation",
    "tool": "grapheneMergeSegments",
    "provider": "graphene"
  },
  "keyc": {
    "layer": "segmentation",
    "tool": "grapheneMulticutSegments",
    "provider": "graphene"
  },
  "keyt": {
    "layer": "annotation",
    "tool": "freeRotateCubeAnnotationTool"
  },
  "keyf": {
    "layer": "segmentation",
    "tool": "grapheneFindPath",
    "provider": "graphene"
  },
  "keyx": false,
  "control+shift+keyx": "clear-segments",
  "bracketleft": "select-previous",
  "bracketright": "select-next"
}
